<template>
  <v-tabs id="tab-menus" center-active class="tabs-container">
    <v-tab
      v-for="(item, index) in sections"
      :key="index"
      :to="{ name: item.pathName }"
    >
      <span class="font_tabs" v-text="$t(item.title)" />
    </v-tab>
  </v-tabs>
</template>

<script>
import sections from "../data/sections";
export default {
  name: "TabMenu",
  data: () => ({
    sections: sections,
  }),
};
</script>
<style lang="scss">
.tabs-container {
  border: solid;
  border-color: rgba($color: #aaa, $alpha: 0.5);
  border-width: 0.2px;
}

.v-tab {
  text-transform: none !important;
}

.v-tab:hover {
  opacity: 0.7;
}
</style>
